module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/hotels-06e328cdd22ceca572a3cf38ae4303d7.png";